import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import { PILLARS } from "../data/content";

const Philosophy = () => (
  <div>
    <PageHero
      overline="Our Philosophy"
      title="Less noise. More nourishment."
      subtitle="NARA exists to simplify daily wellness through rigorous science, clean ingredients and elevated design. We cut the noise, so your body gets what it actually needs."
      image="/images/gen/about_hero.png"
      imageAlt="Elevated wellness, intentional living"
    />

    <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="grid sm:grid-cols-2 gap-6">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div className="flex gap-5 bg-white rounded-3xl p-8 border border-slate-100 hover:shadow-xl transition-all duration-300 h-full">
              <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-sky-50 text-royal shrink-0">
                <Icon name={p.icon} className="w-7 h-7" />
              </span>
              <div>
                <h3 className="font-heading text-xl font-semibold text-navy-900">{p.title}</h3>
                <p className="text-slate-500 mt-2 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-4 md:px-8 pb-24">
      <Reveal>
        <div className="rounded-[2rem] bg-gradient-to-br from-royal to-navy-900 text-white px-8 md:px-16 py-16 text-center">
          <img src="/images/brand/logo_stacked_white.png" alt="NARA Nutrition" className="h-20 w-auto mx-auto mb-8" />
          <span className="text-xs font-bold tracking-[0.22em] uppercase text-sky-300 mb-4 block">Our Promise</span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold tracking-tight">Premium wellness. Reframed.</h2>
          <p className="mt-5 text-slate-300 max-w-lg mx-auto">Rooted in science. Inspired by balance. Made for modern lives.</p>
          <Link to="/science" className="mt-8 inline-flex items-center gap-2 bg-white text-navy-900 rounded-full px-7 py-3.5 font-medium hover:bg-slate-100 transition-colors">
            Our Standards <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
    </section>
  </div>
);

export default Philosophy;
